<template>
  <div id="app" class="min-h-screen bg-gray-50">
    <Header v-if="!isBarePage" />
    <main class="min-h-screen">
      <router-view />
    </main>
    <Footer v-if="!isBarePage" />
  </div>
</template>

<script>
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'

const BARE_PREFIXES = ['/admin', '/voucher/', '/invoice/']

export default {
  name: 'App',
  components: {
    Header,
    Footer
  },
  computed: {
    isBarePage() {
      // On a fresh page load (e.g. the voucher/invoice "Print" link opening
      // in a new tab), vue-router briefly reports the start location ("/")
      // while it resolves the real URL and the auth guard runs. Checking
      // the actual browser URL too avoids a flash of the public header.
      const routePath = this.$route.path
      const realPath = window.location.pathname
      return BARE_PREFIXES.some(prefix => routePath.startsWith(prefix) || realPath.startsWith(prefix))
    }
  }
}
</script>

<style>
#app {
  font-family: 'Open Sans', sans-serif;
}
</style>
